import styles from "./styles.module.css";

const TwoColumnWrapperHeader = ({ children, className }) => {
  return (
    <div className={`${styles.root}${className ? ` ${className}` : ""}`}>
      {children}
    </div>
  );
};

export default TwoColumnWrapperHeader;
export const twoColumnWrapperHeaderStyles = styles;
